"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var error_1 = require("@rill/error");
var request_1 = require("./request");
var response_1 = require("./response");
var Context = /** @class */ (function () {
    /**
     * @description
     * Creates an incoming message context.
     *
     * @example
     * require('http').createServer((req, res) => {
     *   const ctx = new Context(req, res)
     * })
     *
     * @param req An rill/http IncomingMessage.
     * @param res An rill/http ServerResponse.
     */
    function Context(req, res) {
        /** Local data/state for rendering the request. */
        this.locals = {};
        this.req = new request_1.default(this, req);
        this.res = new response_1.default(this, res);
        this.fail = this.fail.bind(this);
        this.assert = this.assert.bind(this);
    }
    /**
     * @description
     * Throw an http during the current request and update the status and message on the response.
     *
     * @example
     * context.fail(400, 'Password is required')
     *
     * @throws {HttpError}
     *
     * @param statusCode The http status code to use for the error.
     * @param statusMessage The http status message to use for the error.
     * @param metaData An object to merge on to the error.
     */
    Context.prototype.fail = function (statusCode, statusMessage, metaData) {
        if (typeof statusCode !== "number") {
            throw new TypeError("Rill#ctx.fail: Status code must be a number.");
        }
        else {
            throw new error_1.default(statusCode, statusMessage, metaData);
        }
    };
    /**
     * @description
     * If a value is falsey throw an http during the current request and update the status and message on the response.
     *
     * @example
     * context.assert(password.length > 5, 400, 'Password must be at least 5 characters long')
     *
     * @throws {HttpError}
     *
     * @param value The value to test for truthyness.
     * @param statusCode The http status code to use for the error.
     * @param statusMessage The http status message to use for the error.
     * @param metaData An object to merge on to the error.
     */
    Context.prototype.assert = function (value, statusCode, statusMessage, metaData) {
        if (typeof statusCode !== "number") {
            throw new TypeError("Rill#ctx.assert: Status code must be a number.");
        }
        if (!value) {
            this.fail(statusCode, statusMessage, metaData);
        }
    };
    return Context;
}());
exports.default = Context;
//# sourceMappingURL=context.js.map